module.exports = __webpack_public_path__ + "img/89.c1042865.png";